import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import AccountService from 'cio/services/account';
import UserModel from 'cio/models/user';

export default class BackupCodesRoute extends Route {
  @service account!: AccountService;

  crumb() {
    return {
      name: 'Two-factor authentication codes',
      path: this.routeName,
    };
  }

  async model() {
    let account = this.account.current;
    let user = account.belongsTo('currentUser').value() as UserModel | null;

    return {
      user,
      codes: await user?.getTwoFactorAuthenticationBackupCodes(),
    };
  }
}
